<template>
  <div>
    <v-card class="mb-8 mt-8 card-ongevallen" v-if="ongevallen">
      <v-card-title class="justify-center">Ongevallen tot nu toe</v-card-title>
      <v-card-text>
        <span class="Ongevallen">{{ongevallen.OngevallenTotNu}}</span>
        <span class="OngevallenChange" v-show="ongevallen.OngevallenInc != 0">
          (
          <span v-show="ongevallen.OngevallenInc > 0">+</span>
          {{ongevallen.OngevallenInc}})
        </span>
        <span class="OngevalIcon">
          <v-icon color="red" x-large v-show="ongevallen.OngevallenInc > 0">mdi-arrow-up-bold</v-icon>
          <v-icon color="green" x-large v-show="ongevallen.OngevallenInc < 0">mdi-arrow-down-bold</v-icon>
          <v-icon color="green" v-show="ongevallen.OngevallenInc == 0">mdi-circle</v-icon>
        </span>
      </v-card-text>
    </v-card>

    <v-card class="mb-8 mt-8 card-vorigeperiode" v-if="ongevallen">
      <v-card-title class="justify-center">Ongevallen vorige {{periodeeenheid.toLowerCase()}}</v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Ongevaltype</th>
                <th class="text-right">Aantal</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(o,i) in ongevallen.VorigePeriode" :key="i">
                <td>{{ o.Naam }}</td>
                <td class="text-right">{{ o.Aantal }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ProjectOngevallen",
  props: {
    periode: {
      type: Number,
      default: null
    },
    project: {
      type: Object,
      default: null
    },
    periodeeenheid: {
      type: String,
      default: null
    },
  },
  data: () => ({
    ongevallen: null
  }),
  methods: {
    loadData: function() {
      if (this.periode && this.project) {
        let data = {
          ProjectId: this.project.Id,
          PeriodeId: this.periode
        };

        this.$api.pProjectDashboardOngevallen(data).then(response => {
          this.ongevallen = response.data[0];
        });
      }
    }
  },
  watch: {
    periode() {
      this.loadData();
    },
    project() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
.Ongevallen {
  font-size: 42px;
  font-weight: bold;
}

.OngevallenChange {
  position: relative;
  top: -8px;
}

.OngevalIcon {
  position: relative;
  top: -10px;
}

.card-ongevallen {
  min-height: 130px;
}

.card-vorigeperiode {
  min-height: 200px;
}
</style>